import React, { useEffect } from "react";
import { setFlowData } from "@/components/PageHome/redux/slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  FlowProps,
  ICON_STYLE,
  MODAL_KEYS,
  MODAL_TYPES,
  renderModalContent,
} from "@/components/PageHome/components/OnboardingSection/Flows/helpers";
import flowSelector from "@/components/PageHome/redux/selectors/flowData";
import { NewMother as NewMotherAttr } from "@/components/PageHome/redux/types";
import { onBoardUser } from "@/components/PageHome/redux/actions";
import { dateToString } from "@/helpers";
import { buttonClickedEvent, dateAddedEvent, popupViewedEvent } from "@/helpers/TSDEvents";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { Actions, ButtonClickedInterface } from "@/helpers/TSDEvents/interfaces";
import refererSelector from "@/redux/slice/global/selectors/refererSelector";

const NewMom: React.FC<FlowProps> = ({ isModalOpen, setIsModalOpen, birthDate, userAgent }) => {
  const flowData = useAppSelector(flowSelector) as NewMotherAttr;
  const signedInStatus = useAppSelector(signedInStateSelector);
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);
  const navSrcSelector = useAppSelector(refererSelector);

  const [selectedModel, setSelectedModel] = React.useState<number>(1);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const closeFunction = FlowData[selectedModel][MODAL_KEYS.onClose];

    if (isModalOpen === false && closeFunction && typeof closeFunction === "function") {
      closeFunction();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      // Hit popup viewed event
      popupViewedEvent({
        popup_name: "Share Little One's Date Of Birth Popup - New Mom",
        popup_position: userAgent?.isMobile ? "bottom" : "top",
        momverse_stage: SegmentInfoObject?.type ? ONBOARDING_STATUS[SegmentInfoObject?.type] : NON_ONBOARDED_STATUS,
        nav_src: navSrcSelector,
      });
    }
  }, [isModalOpen]);

  const dispatchOnBoarding = (): void => {
    dispatch(onBoardUser());

    if (setIsModalOpen) {
      setIsModalOpen(false);
    }
  };

  const handleNewMomButtonClickEvent = (props: { buttonName: string; position?: number }) => {
    const { buttonName, position } = props;
    let payload: ButtonClickedInterface = {
      button_name: buttonName,
      momverse_stage: SegmentInfoObject?.type ? ONBOARDING_STATUS[SegmentInfoObject?.type] : NON_ONBOARDED_STATUS,
      is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
    };

    if (position) {
      payload.button_position = position;
    }

    buttonClickedEvent(payload);
  };

  const FlowData = {
    1: {
      [MODAL_KEYS.type]: MODAL_TYPES.birthDate,
      [MODAL_KEYS.initialDate]: birthDate,
      [MODAL_KEYS.ctaText]: "Submit",
      [MODAL_KEYS.btnClick]: (date: Date): void => {
        if (date) {
          const dateString = dateToString(date);
          dispatch(setFlowData({ ...flowData, birthDate: dateString }));
        }

        dateAddedEvent({
          action: SegmentInfoObject?.segmentDetail?.Birthday?.length > 0 ? Actions.EDIT : Actions.ADD,
          date_type: "birth date",
          date: date.getTime(),
          momverse_stage: SegmentInfoObject?.type ? ONBOARDING_STATUS[SegmentInfoObject?.type] : NON_ONBOARDED_STATUS,
          is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
        });
        handleNewMomButtonClickEvent({ buttonName: "Submit", position: 1 });
        dispatchOnBoarding();
      },
      [MODAL_KEYS.ctaBelowText]: (
        <button
          onClick={() => {
            handleNewMomButtonClickEvent({ buttonName: "I don’t remember my baby’s birthday", position: 2 });
            dispatchOnBoarding();
          }}
        >
          I don’t remember my baby’s birthday
        </button>
      ),
      [MODAL_KEYS.bgIcon]: { iconStyle: ICON_STYLE.style2, className: ["bgIconTopRight"] },
    },
  };

  return renderModalContent(FlowData[selectedModel]);
};

export default NewMom;
